<template>
  <div class="row">
    <!-- Daily Transactions -->
    <div class="col-sm-4">
      <div class="card calc-heigt8">
        <div class="card-body">
          <div class="d-flex mb-3 flex-column">
            <div class="avatar-xs-2 me-3 mb-3">
              <span class="avatar-title rounded-circle bg-dark bg-soft text-success font-size-18">
                <i class="mdi mdi-calendar-text-outline h2 mb-0 pb-0 text-black"></i>
              </span>
            </div>
            <div class="d-flex flex-column">
              <h5 class="font-size-14 mb-0 mt-3 text-black fw-semibold">Daily Transactions</h5>
              <p class="text-grey text-capitalize">{{today}}</p>
            </div>
          </div>
          <div class="text-muted mt-4">
            <div class="d-flex flex-column">
              <p class="mb-0">Collected Revenue</p>
              <div v-if="loading.daily" class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <h4 v-else class="text-black fw-semibold text-uppercase">
                KES {{numberFormat(dashboard.collectionsToday)}}
              </h4>
              <div v-if="!loading.daily && todayVsYesterday > 0">
                <p class="text-muted mb-0 comparison-txt">
                  <span class="text-success me-2 fw-semibold">
                    <i class="mdi mdi-arrow-up"></i>{{numberFormat(todayVsYesterday)}}
                  </span>
                  Since Yesterday
                </p>
              </div>
              <div v-if="!loading.daily && todayVsYesterday === 0">
                <p class="text-muted mb-0 comparison-txt">
                  <span class="text-info me-2 fw-semibold">{{numberFormat(todayVsYesterday)}}</span>
                  Since Yesterday
                </p>
              </div>
              <div v-if="!loading.daily && todayVsYesterday < 0">
                <p class="text-muted mb-0 comparison-txt">
                  <span class="text-danger me-2 fw-semibold">
                    <i class="mdi mdi-arrow-down"></i>{{numberFormat(todayVsYesterday)}}
                  </span>
                  Since Yesterday
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loading.daily" class="card-footer border-top alert-primary text-uppercase alert m-0 border-radius-0">
          <div class="d-flex justify-content-between w-100 fw-bold" title="Own source revenue collections for today">
            <span class="mr-2">OSR</span>
            <span class="text-right">{{numberFormat(dashboard.collectionsTodayOSR)}} ({{getPercentage(dashboard.collectionsTodayOSR, dashboard.collectionsToday)}}%)</span>
          </div>
        </div>

        <div v-if="!loading.daily" class="card-footer border-top alert-success text-uppercase alert m-0 border-radius-0">
          <div class="d-flex justify-content-between w-100 fw-bold" title="Health Related Revenues for Today">
            <span class="mr-2">Health Revenues</span>
            <span class="text-right">{{numberFormat(dashboard.collectionsTodayHEALTH)}} ({{getPercentage(dashboard.collectionsTodayHEALTH, dashboard.collectionsToday)}}%)</span>
          </div>
        </div>

        <div v-if="!loading.daily && !loading.county" class="card-footer bg-black p-4 text-capitalize">
          <p class="text-light opacity-75">
            Achieved <strong class="opacity-100 text-warning-alt">{{((dashboard.collectionsToday/((county.target)/360))*100).toFixed(2)}}%</strong>
            of <strong class="opacity-100 text-warning-alt">{{numberFormat((county.target)/360)}}</strong> target
          </p>
          <div class="progress border-radius-0">
            <div class="progress-bar border-radius-0" :class="progressBarColor"
                 aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
                 :style="{ width: (dashboard.collectionsToday/1400000)*100 + '%' }"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Monthly Transactions -->
    <div class="col-sm-4">
      <div class="card calc-heigt8">
        <div class="card-body">
          <div class="d-flex mb-3 flex-column">
            <div class="avatar-xs-2 me-3 mb-3">
              <span class="avatar-title rounded-circle bg-success bg-soft text-success font-size-18">
                <i class="mdi mdi-calendar-month-outline h2 mb-0 pb-0 text-success"></i>
              </span>
            </div>
            <div class="d-flex flex-column">
              <h5 class="font-size-14 mb-0 mt-3 text-black fw-semibold">Monthly Transactions</h5>
              <p class="text-grey">{{thisMonth}}</p>
            </div>
          </div>
          <div class="text-muted mt-4">
            <div class="d-flex flex-column">
              <p class="mb-0">Collected Revenue</p>
              <div v-if="loading.monthly" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <h4 v-else class="text-black fw-semibold text-uppercase">
                KES {{numberFormat(dashboard.collectionsMonthly)}}
              </h4>

              <div v-if="!loading.monthly && monthlyComparison > 0">
                <p class="text-muted mb-0 comparison-txt">
                  <span class="text-success me-2 fw-semibold">
                    <i class="mdi mdi-arrow-up"></i> {{numberFormat(monthlyComparison)}}
                  </span>
                  Since Last Month
                </p>
              </div>

              <div v-if="!loading.monthly && monthlyComparison === 0">
                <p class="text-muted mb-0 comparison-txt">
                  <span class="text-info me-2 fw-semibold">{{numberFormat(monthlyComparison)}}</span>
                  Since Last Month
                </p>
              </div>

              <div v-if="!loading.monthly && monthlyComparison < 0">
                <p class="text-muted mb-0 comparison-txt">
                  <span class="text-danger me-2 fw-semibold">
                    <i class="mdi mdi-arrow-down"></i> {{numberFormat(monthlyComparison)}}
                  </span>
                  Since Last Month
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loading.monthly" class="card-footer border-top alert-secondary text-uppercase alert m-0 border-radius-0">
          <div class="d-flex justify-content-between w-100 fw-bold" title="Own source revenue collections for the Month">
            <span class="mr-2">OSR</span>
            <span class="text-right">{{numberFormat(dashboard.collectionsMonthlyOSR)}} ({{getPercentage(dashboard.collectionsMonthlyOSR, dashboard.collectionsMonthly)}}%)</span>
          </div>
        </div>

        <div v-if="!loading.monthly" class="card-footer border-top alert-info text-uppercase alert m-0 border-radius-0">
          <div class="d-flex justify-content-between w-100 fw-bold" title="Health Revenues collections for this Month">
            <span class="mr-2">Health Revenues</span>
            <span class="text-right">{{numberFormat(dashboard.collectionsMonthlyHEALTH)}} ({{getPercentage(dashboard.collectionsMonthlyHEALTH, dashboard.collectionsMonthly)}}%)</span>
          </div>
        </div>

        <div v-if="!loading.monthly && !loading.county" class="card-footer bg-primary p-4">
          <p class="text-light opacity-75">
            Achieved <strong class="opacity-100 text-warning-alt">{{((dashboard.collectionsMonthly/((county.target)/12))*100).toFixed(2)}}%</strong>
            of <strong class="opacity-100 text-warning-alt">{{numberFormat((county.target)/12)}}</strong> target
          </p>
          <div class="progress border-radius-0">
            <div class="progress-bar border-radius-0" :class="progressBarColorMonth"
                 aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
                 :style="{ width: (dashboard.collectionsMonthly/(county.target)/12)*100 + '%' }"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Financial Year -->
    <div class="col-sm-4">
      <div class="card calc-heigt8">
        <div class="card-body">
          <div class="d-flex mb-3 flex-column">
            <div class="avatar-xs-2 me-3 mb-3">
              <span class="avatar-title rounded-circle bg-dark bg-soft text-success font-size-18">
                <i class="mdi mdi-calendar-check-outline h2 mb-0 pb-0 text-black"></i>
              </span>
            </div>
            <div class="d-flex flex-column">
              <h5 class="font-size-14 mb-0 mt-3 text-black fw-semibold">This Financial Year</h5>
              <p v-if="!loading.county" class="text-grey">{{getYear(county.financialYearStart)}} - {{getYear(county.financialYearEnd)}}</p>
            </div>
          </div>
          <div class="text-muted mt-4">
            <div class="d-flex flex-column">
              <p class="mb-0">Collected Revenue</p>
              <div v-if="loading.yearly" class="text-center">
                <div class="spinner-border text-dark" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <h4 v-else class="text-black fw-semibold text-uppercase">
                KES {{numberFormat(dashboard.collectionsYearly)}}
              </h4>
            </div>
          </div>
        </div>

        <div v-if="!loading.yearly" class="card-footer border-top alert-primary text-uppercase alert m-0 border-radius-0">
          <div class="d-flex justify-content-between w-100 fw-bold" title="Own source revenue collections for today">
            <span class="mr-2">OSR</span>
            <span class="text-right">{{numberFormat(dashboard.collectionsYearlyOSR)}} ({{getPercentage(dashboard.collectionsYearlyOSR, dashboard.collectionsYearly)}}%)</span>
          </div>
        </div>

        <div v-if="!loading.yearly" class="card-footer border-top alert-success text-uppercase alert m-0 border-radius-0">
          <div class="d-flex justify-content-between w-100 fw-bold" title="Health Related Revenues for Today">
            <span class="mr-2">Health Revenues</span>
            <span class="text-right">{{numberFormat(dashboard.collectionsYearlyHEALTH)}} ({{getPercentage(dashboard.collectionsYearlyHEALTH, dashboard.collectionsYearly)}}%)</span>
          </div>
        </div>

        <div v-if="!loading.yearly && !loading.county" class="card-footer bg-black p-4">
          <p class="text-light opacity-75">
            Achieved <strong class="opacity-100 text-warning-alt">{{((dashboard.collectionsYearly/county.target)*100).toFixed(2)}}%</strong>
            of <strong class="opacity-100 text-warning-alt">{{numberFormat(county.target)}}</strong> target
          </p>
          <div class="progress border-radius-0">
            <div class="progress-bar border-radius-0" :class="progressBarColorYear"
                 aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
                 :style="{ width: (dashboard.collectionsYearly/county.target)*100 + '%' }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { biller, execute } from "@/api";

export default {
  name: "TransactionCards",
  data() {
    return {
      loading: {
        county: true,
        daily: true,
        monthly: true,
        yearly: true,
        paymentStats: true
      },
      county: {
        target: 1,
        financialYearStart: null,
        financialYearEnd: null
      },
      dashboard: {
        collectionsToday: "0",
        collectionsMonthly: "0",
        collectionsYearly: "0",
        collectionsYesterday: "0",
        collectionsLastMonthly: "0",
        collectionsTodayOSR: "0",
        collectionsTodayHEALTH: "0",
        collectionsMonthlyOSR: "0",
        collectionsMonthlyHEALTH: "0",
        collectionsYearlyOSR: "0",
        collectionsYearlyHEALTH: "0",
        customersServed: "0",
        collectionsMpesa: "0",
        collectionsCash: "0",
        collectionsBank: "0",
        totalRevenueCollected: "0"
      }
    }
  },
  computed: {
    progressBarColor() {
      const percentage = (this.dashboard.collectionsToday / 1400000) * 100;
      if (percentage >= 75) return 'bg-success';
      else if (percentage >= 50) return 'bg-info';
      else if (percentage >= 25) return 'bg-warning';
      else return 'bg-danger';
    },
    progressBarColorMonth() {
      const percentage2 = (this.dashboard.collectionsMonthly / 42000000) * 100;
      if (percentage2 >= 75) return 'bg-success';
      else if (percentage2 >= 50) return 'bg-info';
      else if (percentage2 >= 25) return 'bg-warning';
      else return 'bg-danger';
    },
    progressBarColorYear() {
      const percentage2 = (this.dashboard.collectionsYearly / 490895689) * 100;
      if (percentage2 >= 75) return 'bg-success';
      else if (percentage2 >= 50) return 'bg-info';
      else if (percentage2 >= 25) return 'bg-warning';
      else return 'bg-danger';
    },
    monthlyComparison() {
      let thisMonth = Number(this.dashboard.collectionsMonthly);
      let lastMonth = Number(this.dashboard.collectionsLastMonthly);
      return (thisMonth - lastMonth);
    },
    todayVsYesterday() {
      let today = Number(this.dashboard.collectionsToday);
      let yesterday = Number(this.dashboard.collectionsYesterday);
      return today - yesterday;
    },
    today() {
      let today = new Date();
      let formattedDate = today.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
      return formattedDate;
    },
    thisMonth() {
      let today = new Date();
      let formattedMonth = today.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric"
      });
      return formattedMonth;
    }
  },
  mounted() {
    this.loadDashboardData();
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },
    getPercentage(amount, totalAmount) {
      const numericAmount = parseFloat(amount);
      const numericTotalAmount = parseFloat(totalAmount);

      if (isNaN(numericAmount) || isNaN(numericTotalAmount) || numericTotalAmount === 0) {
        return 0;
      }

      return Math.round((numericAmount / numericTotalAmount) * 100);
    },
    getYear(dateString) {
      const date = new Date(dateString);
      return date.getFullYear();
    },

    // Method to create FormData for API calls
    createFormData(functionName) {
      const data = new FormData();
      data.append("function", functionName);
      data.append("sessionNames", localStorage.getItem("sessionNames"));
      data.append("sessionIdNo", localStorage.getItem("sessionIdNo"));
      return data;
    },

    // Load county information first (fastest query)
    async getCountyInfo() {
      try {
        const data = this.createFormData("getCountyInfo");
        const res = await execute(data, biller);

        if (res.data.success) {
          this.county = res.data.data.county;
          this.loading.county = false;
        }
      } catch (e) {
        console.error("Error fetching county info:", e);
        this.loading.county = false;
      }
    },

    // Load daily collections
    async getDailyCollections() {
      try {
        const data = this.createFormData("getDailyCollections");
        const res = await execute(data, biller);

        if (res.data.success) {
          Object.assign(this.dashboard, res.data.data.daily);
          this.loading.daily = false;
        }
      } catch (e) {
        console.error("Error fetching daily collections:", e);
        this.loading.daily = false;
      }
    },

    // Load monthly collections
    async getMonthlyCollections() {
      try {
        const data = this.createFormData("getMonthlyCollections");
        const res = await execute(data, biller);

        if (res.data.success) {
          Object.assign(this.dashboard, res.data.data.monthly);
          this.loading.monthly = false;
        }
      } catch (e) {
        console.error("Error fetching monthly collections:", e);
        this.loading.monthly = false;
      }
    },

    // Load yearly collections
    async getYearlyCollections() {
      try {
        const data = this.createFormData("getYearlyCollections");
        const res = await execute(data, biller);

        if (res.data.success) {
          Object.assign(this.dashboard, res.data.data.yearly);
          this.loading.yearly = false;
        }
      } catch (e) {
        console.error("Error fetching yearly collections:", e);
        this.loading.yearly = false;
      }
    },

    // Load payment statistics
    async getPaymentStats() {
      try {
        const data = this.createFormData("getPaymentStats");
        const res = await execute(data, biller);

        if (res.data.success) {
          Object.assign(this.dashboard, res.data.data.paymentStats);
          this.loading.paymentStats = false;
        }
      } catch (e) {
        console.error("Error fetching payment stats:", e);
        this.loading.paymentStats = false;
      }
    },

    // Main method to orchestrate all API calls
    async loadDashboardData() {
      // Check for cached data first
      const cachedCounty = localStorage.getItem("countyData");
      const cachedDashboard = localStorage.getItem("dashboardData");

      if (cachedCounty && cachedDashboard) {
        try {
          this.county = JSON.parse(cachedCounty);
          this.dashboard = JSON.parse(cachedDashboard);

          // Set all loading states to false if cache exists
          Object.keys(this.loading).forEach(key => {
            this.loading[key] = false;
          });

          // Still refresh data in background
          this.refreshDataInBackground();
          return;
        } catch (e) {
          console.warn("Error parsing cached data, fetching fresh data");
        }
      }

      // Load data sequentially for better perceived performance
      // Start with fastest queries first
      this.getCountyInfo();

      // Small delay between calls to prevent overwhelming the server
      setTimeout(() => {
        this.getDailyCollections();
      }, 100);

      setTimeout(() => {
        this.getMonthlyCollections();
      }, 200);

      setTimeout(() => {
        this.getYearlyCollections();
      }, 300);

      setTimeout(() => {
        this.getPaymentStats();
      }, 400);

      // Cache the data after all calls complete
      this.cacheDataAfterLoading();
    },

    // Refresh data in background when using cache
    async refreshDataInBackground() {
      // Load fresh data without showing loading states
      const tempLoading = { ...this.loading };

      // Don't show loading indicators for background refresh
      Object.keys(this.loading).forEach(key => {
        this.loading[key] = false;
      });

      await Promise.all([
        this.getCountyInfo(),
        this.getDailyCollections(),
        this.getMonthlyCollections(),
        this.getYearlyCollections(),
        this.getPaymentStats()
      ]);

      // Update cache with fresh data
      this.updateCache();
    },

    // Cache data after all loading is complete
    cacheDataAfterLoading() {
      // Wait for all API calls to complete before caching
      const checkLoadingComplete = () => {
        const allLoaded = Object.values(this.loading).every(loading => !loading);

        if (allLoaded) {
          this.updateCache();
        } else {
          setTimeout(checkLoadingComplete, 500);
        }
      };

      setTimeout(checkLoadingComplete, 1000);
    },

    // Update localStorage cache
    updateCache() {
      try {
        localStorage.setItem("countyData", JSON.stringify(this.county));
        localStorage.setItem("dashboardData", JSON.stringify(this.dashboard));
        localStorage.setItem("dashboardCacheTime", Date.now().toString());
      } catch (e) {
        console.warn("Failed to cache dashboard data:", e);
      }
    }
  }
}
</script>

<style scoped>
.spinner-border {
  width: 1.5rem;
  height: 1.5rem;
}

.comparison-txt {
  font-size: 0.875rem;
}

.card {
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
</style>